module.exports = __webpack_public_path__ + "assets/img/news (17).8d6b86fe.png";